import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Lock as LockIcon } from '@mui/icons-material';

interface LoginRequiredDialogProps {
  open: boolean;
  onClose: () => void;
}

const LoginRequiredDialog: React.FC<LoginRequiredDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/signup');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <LockIcon sx={{ mr: 1 }} />
          <Typography variant="h6">Login Required</Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ py: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h5" gutterBottom color="primary.main" fontWeight="bold">
            Please Login to Generate Capsules
          </Typography>
        </Box>
        
        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            mb: 3, 
            bgcolor: 'rgba(0, 180, 216, 0.05)', 
            borderRadius: 2,
            border: '1px solid rgba(0, 180, 216, 0.2)'
          }}
        >
          <Typography variant="body1" paragraph>
            <strong>We're indie developers</strong> and API costs for generating high-quality capsules are significant. 
          </Typography>
          
          <Typography variant="body1" paragraph>
            Login to get <strong>2 free credits every month</strong>. Need more? Check out our affordable plans.
          </Typography>
          
          <Typography variant="body1">
            Your support helps us continue providing this service and improving it further.
          </Typography>
        </Paper>
        
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            By logging in, you'll also be able to save your capsules and access them anytime.
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center' }}>
        <Button 
          onClick={onClose} 
          color="inherit"
          variant="outlined"
          sx={{ borderRadius: 4, px: 3 }}
        >
          Maybe Later
        </Button>
        <Button 
          onClick={handleLogin} 
          color="primary"
          variant="contained"
          sx={{ borderRadius: 4, px: 3, ml: 2 }}
        >
          Login / Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginRequiredDialog;
